import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { Tooltip } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, MenuList, Popover } from '@mui/material';
import { useRef } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var DeleteConfirmation = function DeleteConfirmation(_ref) {
  var handleDelete = _ref.handleDelete,
      isOpen = _ref.isOpen,
      closeDialog = _ref.closeDialog;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "DeleteConfirmation",
    "data-source-file": "ancillary-button.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(Dialog, {
        open: isOpen,
        onClose: closeDialog,
        PaperProps: {
          sx: {
            width: 1,
            maxWidth: 475
          }
        },
        children: [/*#__PURE__*/_jsx(DialogTitle, {
          variant: "h3",
          children: t('Delete reply')
        }), /*#__PURE__*/_jsx(DialogContent, {
          children: /*#__PURE__*/_jsx(DialogContentText, {
            children: t("Are you sure you want to delete this reply? You won't be able to undo this action.")
          })
        }), /*#__PURE__*/_jsxs(DialogActions, {
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "text",
            onClick: closeDialog,
            sx: {
              mr: 1,
              color: function color(t) {
                return t.palette.primary.main;
              }
            },
            children: t('Cancel')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "contained",
            onClick: function onClick() {
              closeDialog();
              handleDelete();
            },
            children: t('Delete')
          })]
        })]
      });
    }
  });
};

var AncillaryButton = function AncillaryButton(_ref2) {
  var deleteComment = _ref2.deleteComment,
      handleEditMore = _ref2.handleEditMore;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      open = _useToggle2$.on,
      close = _useToggle2$.off;

  var _useToggle3 = useToggle(),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      confirmationIsOpen = _useToggle4[0],
      _useToggle4$ = _useToggle4[1],
      openConfirmation = _useToggle4$.on,
      closeConfirmation = _useToggle4$.off;

  var popoverRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      ref: popoverRef,
      sx: {
        mt: 1
      },
      "data-element": "Box",
      "data-component": "AncillaryButton",
      "data-source-file": "ancillary-button.tsx",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: t('More options'),
        "data-element": "Tooltip",
        "data-component": "AncillaryButton",
        "data-source-file": "ancillary-button.tsx",
        children: /*#__PURE__*/_jsx(IconButton, {
          onClick: open,
          "data-element": "IconButton",
          "data-component": "AncillaryButton",
          "data-source-file": "ancillary-button.tsx",
          children: /*#__PURE__*/_jsx(MoreVertIcon, {
            fontSize: "small",
            "data-element": "MoreVertIcon",
            "data-component": "AncillaryButton",
            "data-source-file": "ancillary-button.tsx"
          })
        })
      }), /*#__PURE__*/_jsx(Popover, {
        open: isOpen,
        anchorEl: popoverRef.current,
        onClose: close,
        "data-element": "Popover",
        "data-source-file": "ancillary-button.tsx",
        children: /*#__PURE__*/_jsxs(MenuList, {
          "data-element": "MenuList",
          "data-source-file": "ancillary-button.tsx",
          children: [/*#__PURE__*/_jsx(MenuItem, {
            onClick: handleEditMore,
            "data-element": "MenuItem",
            "data-source-file": "ancillary-button.tsx",
            children: t('Edit reply')
          }), /*#__PURE__*/_jsx(MenuItem, {
            sx: {
              color: function color(t) {
                return t.palette.error.main;
              }
            },
            onClick: openConfirmation,
            "data-element": "MenuItem",
            "data-source-file": "ancillary-button.tsx",
            children: t('Delete reply')
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(DeleteConfirmation, {
      handleDelete: deleteComment,
      isOpen: confirmationIsOpen,
      closeDialog: closeConfirmation,
      "data-element": "DeleteConfirmation",
      "data-source-file": "ancillary-button.tsx"
    })]
  });
};

export default AncillaryButton;